import { Form, Select, Button, Radio, Col, Tooltip, Row, Input } from "antd";
import {
  AuthTitleBlock,
  DetailFields,
  DownArrowDraw,
  HaberForm,
} from "../../Pages/styledElements";
import {
  PaperMachineQualitySelect,
  PaperMachineGradeSelect,
} from "../../Pages/pageStyled";
import { ModalPopup } from "./modal";
import Iconmoon from "../IconsFiles/icon";
import { useContext, useEffect, useState } from "react";
import { getReelCoreValues } from "../../Services/settingsServices";
import styled from "styled-components";
import Multiselect from "multiselect-react-dropdown";
import { getUnitData } from "../../Services/measurementService";
import { editJobCardReelOD } from "../../Services/deckleMatchServices";
import JobCardDataContext from "../../ContextApi/JobCardDataContext";
const { Option } = Select;

const multiselectStyle = {
  chips: {},
  searchBox: {
    border: "2px solid #dfe1e6",
    "border-radius": "8px",
    "background-color": "var(--form-element-bg)",
  },
  option: {
    // To change css for dropdown options
  },
};

const MultiSelectCard = styled.div`
  .optionContainer li:hover,
  .optionContainer .highlight {
    background: #edebe9;
    color: black;
  }
  .multiSelectContainer input[type="text"] {
    padding-left: 15px !important;
    width: 100%;
  }
  .optionContainer .highlight {
    background: white;
    color: black;
  }
  .optionListContainer {
    z-index: 100;
  }
  li.groupHeading {
    color: black;
    padding: 5px 15px;
    pointer-events: none;
    font-weight: 500;
  }
  .multiSelectContainer ul {
    border-radius: 0px;
    margin-top: 4px;
  }
  .multiSelectContainer input[type="checkbox"] {
    accent-color: rgb(234, 101, 91);
  }
  .ant-btn {
    border: 0px solid transparent !important;
  }
`;

export const JobCardReelODEditModal = ({
  visible,
  groupId,
  setIsJobCardReelODEditModalVisible,
  setGlobalReelOD,
  showToaster,
  setActionToaster,
  refresh,
  setShowAlert,
  reelValuesArray = null,
  unitData = null
}) => {
  const { setOrderSummaryTable } = useContext(JobCardDataContext);
  const [reelValues, setReelValues] = useState(reelValuesArray && []);
  const [reelODLevel, setReelODLevel] = useState("JobCard");
  const [reelODType, setReelODType] = useState("Constant");
  const [selectedReelOD, setSelectedReelOD] = useState([]);
  const [measurementData, setMeasurementData] = useState(unitData && null);

  const saveAction = async() => {
    let body = {};
    if (reelODLevel == "JobCard") {
      if (reelODType == "Constant") {
        body = {
          group_id: groupId,
          reel_od: selectedReelOD.map((item) => item.value),
          od_type: "constant",
          cutter_reel_dia: false,
        };
      } else {
        body = {
          group_id: groupId,
          reel_od: {
            minimum_reel_od: parseFloat(form.getFieldValue("min_reel_od")),
            maximum_reel_od: parseFloat(form.getFieldValue("max_reel_od")),
          },
          od_type: "range",
          cutter_reel_dia: false,
          units: {
            minimum_reel_od: form.getFieldValue("reelOD_unit"),
            maximum_reel_od: form.getFieldValue("reelOD_unit"),
          },
        };
      }
      setActionToaster({
        error:false,
        msg:"Selected Orders ReelOD set at JobCard Level",
      })
    } else {
      body = {
        group_id: groupId,
        reset: "reel_od",
        cutter_reel_dia: false,
      };
      setActionToaster({
        error:false,
        msg:"Selected Orders ReelOD reset",
      })
    }

    try{
      const response = await editJobCardReelOD(body);
      if(!response?.error && response?.group_data){
        let data = {};
        if(reelODLevel == "JobCard")
        {
          if(reelODType == "Constant")
          {
            data = {
              level: reelODLevel,
              type: reelODType,
              selectedReelOD: selectedReelOD.map((item) => item.value),
              min_reel_od: 0,
              max_reel_od: 0,
              unit: "",
            };
          }
          else{
            data = {
              level: reelODLevel,
              type: reelODType,
              min_reel_od: form.getFieldValue("min_reel_od"),
              max_reel_od: form.getFieldValue("max_reel_od"),
              unit: form.getFieldValue("reelOD_unit"),
              selectedReelOD: [],
            };
          }
        }
        setGlobalReelOD({ ...data });
        setShowAlert((prev) => ({
          ...prev,
          isGlobalReelODChanged: reelODLevel == "JobCard",
          isReelOrderChanged: false,
          isReelODChanged: false,
        }));
        refresh();
        showToaster();
        setIsJobCardReelODEditModalVisible(false);
      }
      else{
        setActionToaster({
          error:true,
          msg:response?.msg,
        })
        showToaster();
        setIsJobCardReelODEditModalVisible(false);
      }
    }
    catch(e){
      console.log(e);
      setActionToaster({
        error:true,
        msg:e.response.data.msg,
      })
      showToaster();
      setIsJobCardReelODEditModalVisible(false);
    }
    finally{
      setReelODLevel("JobCard");
      setReelODType("Constant");
      form.resetFields(["min_reel_od","max_reel_od","type"]);
      setSelectedReelOD([]);
    }
  }

  const cancelAction = () => {
    setIsJobCardReelODEditModalVisible(false);
    form.resetFields(["min_reel_od","max_reel_od"]);
    setSelectedReelOD([]);
  };

  const onChangeReelOdSelect = (data) => {
    setSelectedReelOD(data);
  };

  const removeReelOD = (data) => {
    setSelectedReelOD(
      selectedReelOD.filter((item) => data.value != item.value)
    );
  };

  const [form] = Form.useForm();

  const reelType = [
    {
      label: "Constant",
      value: "Constant",
    },
    {
      label: "Range",
      value: "Range",
    },
  ];

  const fetchReelDias = async () => {
    try {
      const response = await getReelCoreValues();
      setReelValues(
        response.reel_data.map((item) => ({ value: item[0] + " " + item[1] }))
      );
    } catch (e) {
      console.log(e);
    }
  };
  const fetchUnitsData = async () => {
    try {
      const data = await getUnitData()
      if (!data.error) {
        setMeasurementData(data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    !reelValuesArray && fetchReelDias();
    !unitData && fetchUnitsData();
  }, []);
  return (
    <ModalPopup visible={visible} style={{ width: "335px"}}>
      <div className="resetPassForm removePadLeft">
        <DetailFields className="marginBtnP" style={{ paddingBottom: "15px" }}>
          <div className="header">
            <h3>Reel Outer Diameter</h3>
          </div>
          <HaberForm>
            <Form
              name="JobCardReelOD"
              autoComplete="off"
              className="haberLogin haberSignup"
              style={{ marginTop: "0" }}
              form={form}
              onFinish={() => {}}
              initialValues={{reelOD_unit: measurementData?.data.units_management?.length?.default}}
            >
              <div
                className="drawerField"
                style={{
                  borderBottom: "0px solid #edebe9",
                }}
              >
                <Form.Item
                  className=" switchRadio twoSwitch"
                  style={{
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <Radio.Group
                    options={["JobCard", "Order"]}
                    optionType="button"
                    buttonStyle="solid"
                    value={reelODLevel}
                    onChange={(e) => setReelODLevel(e.target.value)}
                  />
                </Form.Item>
                {reelODLevel == "JobCard" && (
                  <div>
                    <p
                      style={{
                        marginLeft: "3px",
                      }}
                    >
                      Type
                    </p>
                    <Form.Item name="type" className="selectForm">
                      <Select
                        defaultValue="Constant"
                        suffixIcon={<DownArrowDraw />}
                        onChange={(e) => setReelODType(e)}
                      >
                        {reelType.map(({ label, value }) => (
                          <Option key={value}>{label}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                    {reelODType == "Constant" ? (
                      <>
                        <p
                          style={{
                            marginLeft: "3px",
                            marginBottom: "4px",
                          }}
                        >
                          Reel OD
                        </p>
                        <Col name="reelOD" className="blockBreak">
                          <div className="boxFormType">
                            <PaperMachineQualitySelect>
                              <MultiSelectCard>
                                <Multiselect
                                  className="multiQuality"
                                  options={reelValues}
                                  style={multiselectStyle}
                                  showArrow={true}
                                  selectedValues={selectedReelOD}
                                  displayValue={"value"}
                                  showCheckbox={true}
                                  onSelect={onChangeReelOdSelect}
                                  onRemove={onChangeReelOdSelect}
                                  hideSelectedList
                                  keepSearchTerm
                                />
                              </MultiSelectCard>
                            </PaperMachineQualitySelect>
                            <PaperMachineGradeSelect>
                              <div
                                className="mainMachineGrade"
                                style={{ marginTop: "15px" }}
                              >
                                {selectedReelOD &&
                                  selectedReelOD?.map((item, index) => {
                                    return (
                                      index < 2 && (
                                        <span
                                          className={
                                            "MachineGradeSelect-active"
                                          }
                                        >
                                          {item.value}
                                          <Button
                                            style={{
                                              border: "0px solid transparent",
                                              margin: "0px !important",
                                              background: "#fdf0ef",
                                            }}
                                            className=" textBtnIcon paperButtonBg"
                                            onClick={() => {
                                              removeReelOD(item);
                                            }}
                                          >
                                            <Iconmoon
                                              icon="wrong"
                                              size={14}
                                              color="#EA655B"
                                            />
                                          </Button>
                                        </span>
                                      )
                                    );
                                  })}
                              </div>
                              {selectedReelOD &&
                                selectedReelOD?.length >= 2 &&
                                selectedReelOD?.map((item, index) => {
                                  let tooltipData = "";
                                  for (
                                    let index = 2;
                                    index < selectedReelOD?.length;
                                    index++
                                  ) {
                                    const data = selectedReelOD[index];
                                    tooltipData =
                                      tooltipData + data.value + ", ";
                                  }
                                  tooltipData = tooltipData.substring(
                                    0,
                                    tooltipData.length - 1
                                  );
                                  return (
                                    index == 2 && (
                                      <Tooltip title={tooltipData}>
                                        {" "}
                                        <span
                                          style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          & {selectedReelOD.length - 2} More
                                        </span>
                                      </Tooltip>
                                    )
                                  );
                                })}
                            </PaperMachineGradeSelect>
                          </div>
                        </Col>
                      </>
                    ) : (
                        <div style={{ marginTop: "20px" }}>
                          <Col span={24}>
                            <Row className="centerAlign justifyCSBetween">
                              <Col
                                span={9}
                                className="blockBreak"
                                style={{ paddingRight: "5px" }}
                              >
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    label="Min Reel OD"
                                    name="min_reel_od"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Min Reel OD is required",
                                      },
                                      {
                                        pattern: new RegExp(
                                          /^\d+(\.\d{0,3})?$/
                                        ),
                                        message:
                                          "Only Numeric value is possible upto 3 decimal point",
                                      },
                                      {
                                        pattern: new RegExp(
                                          // /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                          /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                        ),
                                        message:
                                          "Value should be a number greater than zero",
                                      },
                                      {
                                        validator: (_, value) => {
                                          const max_reel_od =
                                            form.getFieldValue("max_reel_od");
                                          if (
                                            parseFloat(value) >
                                            parseFloat(max_reel_od)
                                          ) {
                                            return Promise.reject(
                                              "Min Reel OD must be less than equal to Max Reel OD"
                                            );
                                          }
                                          return Promise.resolve();
                                        },
                                      },
                                    ]}
                                    className="dBlock"
                                  >
                                    <Input placeholder="Min Reel OD" />
                                  </Form.Item>
                                </div>
                              </Col>
                              <Col
                                span={9}
                                className="blockBreak"
                                style={{ paddingRight: "5px" }}
                              >
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    label="Max Reel OD"
                                    name="max_reel_od"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Max Reel OD is required",
                                      },
                                      {
                                        pattern: new RegExp(
                                          /^\d+(\.\d{0,3})?$/
                                        ),
                                        message:
                                          "Only Numeric value is possible upto 3 decimal point",
                                      },
                                      {
                                        pattern: new RegExp(
                                          /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                        ),
                                        message:
                                          "Value should be a number greater than zero",
                                      },
                                      {
                                        validator: (_, value) => {
                                          const max_reel_od =
                                            form.getFieldValue("max_reel_od");
                                          if (
                                            parseFloat(value) >
                                            parseFloat(max_reel_od)
                                          ) {
                                            return Promise.reject(
                                              "Min Reel OD must be less than equal to Max Reel OD"
                                            );
                                          }
                                          return Promise.resolve();
                                        },
                                      },
                                    ]}
                                    className="dBlock"
                                  >
                                    <Input placeholder="Max Reel OD" />
                                  </Form.Item>
                                </div>
                              </Col>
                              <Col span={6} className="blockBreak">
                                <div className="boxFormType unitSelect">
                                  <Form.Item
                                    label="Unit"
                                    name="reelOD_unit"
                                    rules={[]}
                                    className="dBlock"
                                  >
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      className="dBlock"
                                    >
                                      {measurementData?.data.units_management.length.data?.map(
                                        (reelUnit) => (
                                          <Option
                                            key={reelUnit}
                                            value={reelUnit}
                                          >
                                            {reelUnit}
                                          </Option>
                                        )
                                      )}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                    )}
                  </div>
                )}
              </div>
            </Form>
          </HaberForm>
        </DetailFields>
      </div>
      <div className="ant-modal-footer-section">
        <Button key="submit" className="themeBtn" onClick={saveAction}>
          <Iconmoon icon="edit" size={14} color="#ffff" />
          Save
        </Button>
        <Button key="back" className="themeBtn-plane" onClick={cancelAction}>
          <div className="plusPopUpBorder">
            <Iconmoon
              icon="plus-sign"
              size={9}
              color="#EA655B"
              className="ant-ico-sec"
            />
          </div>
          Cancel
        </Button>
      </div>
    </ModalPopup>
  );
};